import React, { useEffect, useRef } from "react";
import { GetServerSideProps } from "next";
import Head from "next/head";
import PageLayoutV1 from "@app/hocs/PageLayoutV1";
import * as CmsHttp from "@app/http/cms";
import { ATS_IFRAME_URL, META_DESCRIPTION, META_URL } from "@app/utilities/constants";

const CareersPage: React.FC = () => {
  const mainElem = useRef<HTMLIFrameElement>();

  function onMessage(evt) {
    const { data } = evt;

    if (evt?.origin === "https://heritagecounseling.rippling-ats.com" && mainElem.current) {
      const { command, height } = data;

      switch (command) {
        case "resize":
          if (height > 300) {
            mainElem.current.style.height = height + "px";
          }
          break;
        case "reset":
          mainElem.current.style.height = "300px";
          break;
        default:
          break;
      }
    }
  }

  useEffect(() => {
    window.addEventListener("message", onMessage);

    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);
  /**
   * Meta contents
   */
  const metaTitle = `Careers | Heritage Counseling`,
    metaDescription = META_DESCRIPTION || "",
    metaUrl = `${META_URL}/careers`,
    metaImage = `${META_URL}/logo.png`;

  return (
    <PageLayoutV1 title="Careers" fluidContainer={false} noPadding={false}>
      <Head>
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={metaUrl} />
        <meta property="og:image" content={metaImage} />

        <meta name="twitter:url" content={metaUrl} />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={metaImage} />

        <meta itemProp="title" content={metaTitle} />
        <meta itemProp="description" content={metaDescription} />

        <link rel="canonical" href={metaUrl} />
      </Head>
      <div className="careers-page" data-testid="careers-page">
        <iframe
          src={ATS_IFRAME_URL}
          scrolling="no"
          ref={mainElem}
          style={{
            width: "1px",
            minWidth: "100%",
            border: "none",
            height: "903px",
          }}
        ></iframe>
      </div>
    </PageLayoutV1>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const geolocations = await CmsHttp.getGeolocations();

  return {
    props: {
      geolocations,
    },
  };
};

export default CareersPage;
